export interface CatalogDelayCode {
	DelayCodeId: number | null;
	DelayCodeName: string;
	DelayCategoryId: number | null;
	DelayCategoryName: string | null;
	DelayCategoryColor: string | null;
	ParentDelayCodeId: number | null;
	DelayAreaAssetId: number | null;
	IsAtTop: boolean;
	IsAtBottom: boolean;
	IsBranch: boolean;
	SortOrder: number | null;
	IsSelectable: boolean;
	IsEditable: boolean;
	IsActive: boolean | null;
}

export const CATALOG_DELAY_INITIAL_VALUES: CatalogDelayCode = {
	DelayCodeId: null,
	DelayCodeName: "",
	DelayCategoryId: null,
	DelayCategoryName: null,
	DelayCategoryColor: null,
	ParentDelayCodeId: null,
	DelayAreaAssetId: null,
	IsAtTop: false,
	IsAtBottom: false,
	IsBranch: false,
	SortOrder: null,
	IsSelectable: true,
	IsEditable: true,
	IsActive: true,
};

export interface DelayAreaAsset {
	AssetId: number;
	AssetName: string;
}
